import firebase from "firebase";

export const getCurrentUser = async (project_id, uid) => {
  let currentUser = null;
  const data = await firebase.firestore()
    .collection('projects')
    .doc(project_id)
    .collection('users')
    .where('uid', '==', uid)
    .get()


  data.forEach((subDoc) => {
    currentUser = subDoc.data();
  });

  return currentUser;
}

export const getPermission = async (project_id, uid) => {
  let currentUser = await getCurrentUser(project_id, uid);

  if (currentUser.role === 'admin') {
    return {
      available_jobs: null,
      available_objects: null
    }
  }

  let user = {};
  const user_d = await firebase.firestore()
    .collection('projects')
    .doc(project_id)
    .collection('users')
    .where('isCompany', '==', true)
    .where('company', '==', currentUser.company)
    .get();

  user_d.forEach((subDoc) => {
    user = subDoc.data();
  });

  if (!user.usePermission) {
    return {
      available_jobs: null,
      available_objects: null,
    }
  }

  return {
    available_jobs: user.available_jobs || [],
    available_objects: user.available_objects || []
  }
}

export const getPermissionDocs = async (project_id, uid) => {
  let currentUser = await getCurrentUser(project_id, uid);

  if (currentUser.role === 'admin') {
    return {
      available_files: null,
      available_docs: null
    }
  }

  let user = {};
  const user_d = await firebase.firestore()
    .collection('projects')
    .doc(project_id)
    .collection('users')
    .where('isCompany', '==', true)
    .where('company', '==', currentUser.company)
    .get();

  user_d.forEach((subDoc) => {
    user = subDoc.data();
  });

  if (!user.usePermissionDocs) {
    return {
      available_files: null,
      available_docs: null,
    }
  }

  return {
    available_files: user.available_files || [],
    available_docs: user.available_docs || []
  }
}

export const getRole = async (project_id) => {
  const sub = await firebase.firestore()
    .collection('projects')
    .doc(project_id).get();

  const data = sub.data();
  let role = 'admin';
  if (data) {
    const rules = data.rules;
    if (rules) {
      role = rules[firebase.auth().currentUser.uid];
      if (data.isDemo) {
        role = 'admin';
      }
    }
  }

  return role;
}

export const getMyCompanyUsers = async (project_id) => {
  let currentUser = await getCurrentUser(project_id, firebase.auth().currentUser.uid);


  const user_d = await firebase.firestore()
    .collection('projects')
    .doc(project_id)
    .collection('users')
    .where('company', '==', currentUser.company)
    .get();
  const result = [];

  user_d.forEach((subDoc) => {
    result.push(subDoc.data().uid);
  });

  return result;
}



// WEBPACK FOOTER //
// ./src/firestore/permission.js